import { createClient, fetchExchange } from '@urql/core'

// The doctors API client CFindADoctor queries regions with (from the browser).
// Its own module so importing it does not bundle the discovericl schema.
export const doctorsClient = createClient({
  url: 'https://doctors.discovericl.com/api',
  exchanges: [fetchExchange],
})
